import {create} from "zustand";

export type NotificationPermissionStatus = NotificationPermission | "unsupported";

type NotificationPermissionStore = {
  status: NotificationPermissionStatus;
  setStatus: (status: NotificationPermissionStatus) => void;
};

const initialStatus: NotificationPermissionStatus =
  typeof window !== "undefined" && "Notification" in window ? Notification.permission : "default";

export const useNotificationPermissionStore = create<NotificationPermissionStore>((set) => ({
  status: initialStatus,
  setStatus: (status) => set({status}),
}));

export const useNotificationPermissionStatus = () =>
  useNotificationPermissionStore((state) => state.status);

